export default {
  title: "",
  subtitle: "For Settlements",
  path: "transaction_status_settlements",
  paragraph: "",
  request: {},
   domainsProperties: [
    {
      name: "wired",
      values: "the exchanged value has been wired to its destination – your external international bank account overseas - that is also the final state."
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/TransactionsStatusSettlements.js